import React from 'react';
import { StructuredText } from 'react-datocms';
import { buildModule } from '@/components/Modules';
import { Band } from '@/components/Modules/Band/Band';
import type { Document } from 'datocms-structured-text-utils';
import type { FaqAccordionFragment } from '@/utils/dato/generated';
import { Accordion, FlexRow, FlexCol } from '@zopauk/react-components';
import { customNodeRules, renderBlock } from '@/components/structuredText';

const FaqAccordion = ({ header, button, faqs }: FaqAccordionFragment) => (
  <Band data-automation="ZA.faqAccordion-band">
    <FlexRow justify="center">
      <FlexCol xl={6} l={8}>
        {header ? (
          <div className="text-left lg:text-center">
            <h2 className="text-4xl lg:text-5xl my-4 font-serif font-semibold mb-6 lg:mb-7">{header}</h2>
          </div>
        ) : null}
        <Accordion className="accordion-overwrite" aria-label="Loans faq">
          {faqs.map(({ title, body, id }, index) =>
            body ? (
              <div key={id}>
                <Accordion.Header className={index + 1 !== faqs.length ? 'mb-2' : ''} index={index} id={id}>
                  <div style={{ textAlign: 'left' }}>{title}</div>
                </Accordion.Header>
                <Accordion.Section index={index} id={id}>
                  <div style={{ paddingBottom: '15px', paddingTop: '15px' }}>
                    <StructuredText
                      data={{ value: body.value as Document, blocks: body.blocks }}
                      customNodeRules={customNodeRules}
                      renderBlock={renderBlock}
                    />
                  </div>
                </Accordion.Section>
              </div>
            ) : null,
          )}
        </Accordion>
        {button[0] ? (
          <div className="mt-8 lg:mt-10 flex justify-center">{buildModule({ module: button[0] })}</div>
        ) : null}
      </FlexCol>
    </FlexRow>
  </Band>
);

export default FaqAccordion;
